export default __webpack_public_path__ + "static/media/Home-section-2.ddfad5eb.svg";